<template src="./Slider.html"></template>
<style src="./Slider.scss" lang="scss"></style>

<script>
	import Teaser from '@/components/Teaser/Teaser';

	const SLIDE_DIRECTIONS = {
		leftright: 'leftright',
		rightleft: 'rightleft',
		topbottom: 'topbottom',
		bottomtop: 'bottomtop',
		fade: 'fade'
	};

	const INDICATOR_POSITIONS = {
		top: 'top',
		bottom: 'bottom',
		left: 'left',
		right: 'right'
	};

	export default {
		data () {
			return {
				current: 0,
				slideTrack: null,
				slides: [],
				indicators: [],
				autoslide: '',
				indicatorsData: [],
				touchDetector: {
					startX: '',
					startY: '',
					endX: '',
					endY: ''
				}
			};
		},
		props: {
			elements: Array,
			slideDirection: {
				type: String,
				required: false,
				default: SLIDE_DIRECTIONS.leftright
			},
			indicatorPosition: {
				type: String,
				required: false,
				default: INDICATOR_POSITIONS.top
			},
			interval: {
				type: Number,
				required: false,
				default: 0
			},
			showArrows: {
				type: Boolean,
				required: false,
				default: true
			},
			showIndicators: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		components: {
			'hp-teaser': Teaser
		},
		methods: {
			goPrev () {
				this.current === 0 ? (this.current = this.slides.length - 1) : this.current--;
				this.moveContentWrapper();
			},
			goNext () {
				this.current === this.slides.length - 1 ? (this.current = 0) : this.current++;
				this.moveContentWrapper();
			},
			goTo (ev) {
				this.current = ev.currentTarget.dataset.indicator !== undefined ? +ev.currentTarget.dataset.indicator : +ev.currentTarget.parentElement.dataset.indicator;
				this.moveContentWrapper();
			},
			rulerRightHandler (element, container, reference) {
				const ruler = Math.abs(container.offsetLeft) + reference.offsetWidth;
				const offsetRight = element.offsetLeft + element.offsetWidth - 1; // remove the overlapped 1px
				if (offsetRight > ruler) {
					container.style.left = reference.offsetWidth - offsetRight + 'px';
				}
			},
			rulerLeftHandler (element, container, reference) {
				if (Math.abs(container.offsetLeft) > element.offsetLeft) {
					container.style.left = 0 - element.offsetLeft + 'px';
				}
			},
			moveContentWrapper () {
				switch (this.slideDirection) {
					case SLIDE_DIRECTIONS.topbottom: {
						this.slideTrack.style = `top: -${this.current * this.slides[0].offsetHeight}px;`;
						break;
					}
					case SLIDE_DIRECTIONS.bottomtop: {
						this.slideTrack.style = `top: ${this.current * this.slides[0].offsetHeight}px;`;
						break;
					}
					case SLIDE_DIRECTIONS.leftright: {
						this.slideTrack.style = `left: -${this.current * this.slides[0].offsetWidth}px;`;
						break;
					}
					case SLIDE_DIRECTIONS.rightleft: {
						this.slideTrack.style = `left: ${this.current * this.slides[0].offsetWidth}px;`;
						break;
					}
					default: {
					}
				}
			},
			startSlide () {
				this.autoslide = setInterval(this.goNext, +this.interval);
			}
		},
		mounted () {
			this.$nextTick(() => {
				if (this.showIndicators) {
					if (this.elements) {
						this.indicatorsData = this.elements.map((element) => {
							return {
								text: element.article.header.label.text,
								img: element.article.header.label.img,
								href: element.link.href
							}
						});
					}
				}

				document.documentElement.addEventListener('gridGapChanged', this.moveContentWrapper);
				document.documentElement.addEventListener('colCountChanged', this.moveContentWrapper);
			});

			this.$nextTick().then(() => {
				this.slideTrack = this.$el.querySelector('[data-wrapper] > div');
				this.slides = this.$el.querySelectorAll('[data-wrapper] > div > [data-component]');
				this.indicators = this.$el.querySelectorAll('[data-part="indicators"] [data-indicator]');

				if (this.slides.item(this.current)) {
					this.slides.item(this.current).toggleAttribute('data-current', true);
				}

				if (this.indicators.item(this.current)) {
					this.indicators.item(this.current).toggleAttribute('data-current', true);
				}

				if (+this.interval) {
					this.startSlide();
					this.$el.addEventListener('mouseover', () => {
						clearInterval(this.autoslide);
					});
					this.$el.addEventListener('mouseout', () => {
						this.startSlide();
					});
				}
			});
		},
		watch: {
			current: function () {
				const target = this.indicators.item(this.current);
				// Make movement of the indicators
				const elIndicators = (target && target.parentNode) || null;
				if (!elIndicators) {
					return elIndicators;
				}
				// Check whether target is in visual zone
				this.rulerRightHandler(target, elIndicators, this.$el);
				this.rulerLeftHandler(target, elIndicators, this.$el);
				// If target has next sibling, check whether target.nextSibling is in visual zone
				target.nextSibling && target.offsetWidth + target.nextSibling.offsetWidth < this.$el.offsetWidth && this.rulerRightHandler(target.nextSibling, elIndicators, this.$el);
				// If target has previous sibling, check whether target.nextSibling is in visual zone
				target.previousSibling && target.offsetWidth + target.previousSibling.offsetWidth < this.$el.offsetWidth && this.rulerLeftHandler(target.previousSibling, elIndicators, this.$el);

				this.slides.forEach((item, index) => item.toggleAttribute('data-current', index === this.current));
				this.indicators.forEach((item, index) => item.toggleAttribute('data-current', index === this.current));
			}
		},
		beforeDestroy () {
			clearInterval(this.autoslide);
		}
	};
</script>
